import { httpClient } from '@/infra/protocols/http';

export interface IContextConfigurationScript {
  url: string[];
  goal?: string;
  topic?: string;
  content: string;
  audience?: string;
  openingText?: string;
  closingText?: string;
  attachedFiles: string[];
}

export interface IContextConfigurationScriptDTO {
  url: string[];
  objetivo?: string;
  temaCentral?: string;
  publicoAlvo?: string;
  conteudoTexto: string;
  textoAbertura?: string;
  textoFechamento?: string;
  conteudoBaseArquivos: string[];
}

export namespace GetContextConfigurationScriptService {
  export interface Params {
    projectId: string;
    podcastId: string;
    episodeId: string;
  }

  export type Response = IContextConfigurationScript;
}

export async function getContextConfigurationScript(
  params: GetContextConfigurationScriptService.Params,
): Promise<GetContextConfigurationScriptService.Response> {
  const response = await httpClient.get<IContextConfigurationScriptDTO>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}/roteiro/contexto`,
  );

  return {
    url: response.url ?? [],
    goal: response.objetivo,
    topic: response.temaCentral,
    audience: response.publicoAlvo,
    content: response.conteudoTexto,
    openingText: response.textoAbertura,
    closingText: response.textoFechamento,
    attachedFiles: response.conteudoBaseArquivos ?? [],
  };
}
